import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Mon Jul 24 2019
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, computed } from 'mobx';

var AbstractFilterFormStore =
/*#__PURE__*/
function () {
  function AbstractFilterFormStore() {
    _classCallCheck(this, AbstractFilterFormStore);
  }

  _createClass(AbstractFilterFormStore, [{
    key: "getFilteredValues",

    /**
     * Getter for filtered values for filter form
     * @returns <T>
     */
    value: function getFilteredValues() {
      return this.filteredValues;
    }
    /**
     * Setter for initial values for form filter
     * @param initialValues
     */

  }, {
    key: "setInitialValues",
    value: function setInitialValues(initialValues) {
      this.initialValues = initialValues;
      this.filteredValues = initialValues;
    }
    /**
     * Setter for filtered values for form filter
     * @param values
     */

  }, {
    key: "setFilteredValues",
    value: function setFilteredValues(values) {
      this.filteredValues = values;
    }
    /**
     * @returns empty {@link SelectOptions}
     */

  }, {
    key: "getEmptySelectOptions",
    value: function getEmptySelectOptions() {
      return {
        options: [],
        filterOptions: function filterOptions() {
          return [];
        }
      };
    }
  }, {
    key: "getInitialValues",

    /**
     * Getter for initial values for filter form
     * @returns <T>
     */
    get: function get() {
      return this.initialValues;
    }
  }]);

  return AbstractFilterFormStore;
}();

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], AbstractFilterFormStore.prototype, "getInitialValues", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Object)], AbstractFilterFormStore.prototype, "getFilteredValues", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], AbstractFilterFormStore.prototype, "setInitialValues", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], AbstractFilterFormStore.prototype, "setFilteredValues", null);

export default AbstractFilterFormStore;